import { Component, OnInit } from '@angular/core';
import { BaseClass } from "src/app/shared/classes/base";
import { ModalController, NavParams, ToastController } from "@ionic/angular";
import { TranslationService } from "src/app/shared/services/translation.service";
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';
@Component({
    selector: 'app-confirm-close-step-modal',
    templateUrl: './confirm-close-step-modal.component.html',
    styleUrls: ['./confirm-close-step-modal.component.scss'],
})
export class ConfirmCloseStepModalComponent extends BaseClass implements OnInit {
    forceCloseSelfEvaluationStep: boolean;
    constructor(
            protected _toastController: ToastController,
            protected _translationService: TranslationService,
            private _modalController: ModalController,
            private _navParams: NavParams,
            private _configService: ConfigService
    ) {
        super(_toastController, _translationService);
    }

    ngOnInit() {
        this.forceCloseSelfEvaluationStep = this._configService.settings.features.forceCloseSelfEvaluationStep;
    }

    public async dismiss(): Promise<void> {
        await this._modalController.dismiss();
    }

    public async confirm() {
        await this._modalController.dismiss(true);
    }
}

